import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

function CheckItem({ ok, label }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, py: 0.5 }}>
      {ok ? (
        <CheckCircleOutlineIcon color="success" sx={{ fontSize: 18, mt: 0.2 }} />
      ) : (
        <ErrorOutlineIcon color="error" sx={{ fontSize: 18, mt: 0.2 }} />
      )}
      <Typography variant="body2" color={ok ? 'text.primary' : 'error.main'}>
        {label}
      </Typography>
    </Box>
  );
}

function PublishChecklist({ coverTitle, coverImageUrl, summary, hasPayload, hotTake }) {
  return (
    <Box sx={{ mt: 2, p: 1.5, bgcolor: 'action.hover', borderRadius: 1 }}>
      <Typography
        variant="caption"
        fontWeight={600}
        color="text.secondary"
        display="block"
        gutterBottom
      >
        Pre-publish checklist (Pulse)
      </Typography>
      <CheckItem ok={!!coverTitle?.trim()} label="Title set" />
      <CheckItem ok={!!summary?.trim()} label="Summary set (Pulse body)" />
      <CheckItem ok={!!coverImageUrl?.trim()} label="Cover image set (clean 5:2 crop)" />
      <CheckItem ok={!!hasPayload} label="Generated content present" />
      <CheckItem ok={!!hotTake?.trim()} label="Hot take question set (recommended)" />
      <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
        Publish needs title + cover image (+ generated payload). Summary is the same text Pulse
        shows under the title (max 150 chars). Cover is a clean photo — title is not burned in.
        Slide images optional. No publish cap. Not shown on Discover.
      </Typography>
    </Box>
  );
}

export default PublishChecklist;
